import React from "react";

const AgreementDoc = () => {
  return (
    <>
      <b>
        Comprehensive Author-Publisher Agreement for KleverBook™ Program with
        Revenue Sharing Details
      </b>
      <br />
      <br />
      This Agreement is made and entered into as of the date of acceptance (the
      “Effective Date”) by and between decade 2 publishing (d2p), a division of
      Continent 5 Media Group, Inc., and the undersigned Author or Publisher
      (“Seller”). This Agreement sets forth the terms and conditions under which
      the Seller may distribute and promote their literary works through the
      KleverBook™ Program, including detailed revenue-sharing provisions.
      <br />
      <br />
      <b>1. Grant of Rights</b>
      <br />
      1.1 The Seller grants d2p the non-exclusive right to distribute, host, and
      promote the Seller’s literary works (the “Works”) through the KleverBook™
      Program.
      <br />
      1.2 The Seller retains all rights, titles, and interests in and to the
      Works, except as explicitly granted to d2p under this Agreement.
      <br />
      1.3 d2p is authorized to embed advertising content within the Works as
      described in Section 5.
      <br />
      <br />
      <b>2. Revenue Sharing</b>
      <br />
      2.1 Ad Revenue Streams:
      <ul>
        <li>
          Ads are embedded at strategic locations within KleverBooks (e.g.,
          chapter ends or every 15 pages).
        </li>
      </ul>
      2.2 Revenue Allocation:
      <ul>
        <li>
          Revenue generated by KleverBook™ ad is shared equally:
          <ul>
            <li>50% to the Author/Publisher</li>
            <li>50% to the d2p Platform (C5M).</li>
          </ul>
        </li>
      </ul>
      2.3 Video and static ads generate revenue based on the pricing tiers
      defined in Section 5.
      <br />
      2.4 Sales Commissions:
      <ul>
        <li>
          Hyperlinked ads allow readers to purchase directly from ads,
          generating commission revenue for the platform’s operational income.
        </li>
        <li>
          C5M DOES NOT SHARE COMMISSION REVENUE WITH THE AUTHOR/PUBLISHER.
        </li>
      </ul>
      <br />
      <b>3. Seller Responsibilities</b>
      <br />
      3.1 The Seller is responsible for:
      <ul>
        <li>
          Providing accurate and high-quality metadata, descriptions, and
          digital files.
        </li>
        <li>
          Ensuring their Works do not infringe on copyright, trademark, or other
          intellectual property rights.
        </li>
        <li>Setting the retail price of their Works.</li>
      </ul>
      3.2 The Seller warrants that their Works are free of malicious code and do
      not violate any laws or regulations.
      <br />
      <br />
      <b>4. Payments</b>
      <br />
      4.1 d2p will remit payments to the Seller monthly, provided the Seller’s
      account balance meets or exceeds $50.
      <br />
      4.2 Payments will be made via the method selected by the Seller in their
      account settings or retained within the eMoney network for reinvestment.
      <br />
      <br />
      <b>5. KleverBook™ Program Features and Ad Pricing</b>
      <br />
      5.1 Ad-Supported Distribution:
      <ul>
        <li>
          d2p embeds unskippable 30-second video or static ads within the
          Seller’s Works.
        </li>
        <li>Ads are placed based on the following pricing tiers:</li>
      </ul>
      <table border="1" cellspacing="0" cellpadding="4">
        <thead>
          <tr>
            <th>Level</th>
            <th>Priority</th>
            <th>Static Ad Price ($)</th>
            <th>Video Ad Price ($)</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Level 1</td>
            <td>Premium Slots (Bid)</td>
            <td>Minimum Bid: $12</td>
            <td>Minimum Bid: $18</td>
          </tr>
          <tr>
            <td>Level 2</td>
            <td>High-Priority Slots</td>
            <td>$8</td>
            <td>$12</td>
          </tr>
          <tr>
            <td>Level 3</td>
            <td>Standard Slots</td>
            <td>$6</td>
            <td>$9</td>
          </tr>
          <tr>
            <td>Level 4</td>
            <td>Economy Slots</td>
            <td>$5</td>
            <td>$7.50</td>
          </tr>
          <tr>
            <td>Level 5</td>
            <td>Low-Demand Slots</td>
            <td>$3</td>
            <td>$4.50</td>
          </tr>
          <tr>
            <td>Level 6</td>
            <td>Free Slots</td>
            <td>Free Ads (Limited)</td>
            <td>N/A</td>
          </tr>
        </tbody>
      </table>
      <br />
      5.2 Advertising Packages:
      <ul>
        <li>
          Sellers and advertisers can choose bundled advertising packages for
          optimized exposure:
        </li>
      </ul>
      <table border="1" cellspacing="0" cellpadding="4">
        <thead>
          <tr>
            <th>Package</th>
            <th>Price</th>
            <th>Details</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Starter Package</td>
            <td>$50</td>
            <td>3 static ads (Level 3) + 1 video ad (Level 4).</td>
          </tr>
          <tr>
            <td>Engagement Package</td>
            <td>$100</td>
            <td>
              2 video ads (Level 2) + 3 static ads (Level 3) + 1 static ad
              (Level 1).
            </td>
          </tr>
          <tr>
            <td>Premium Exposure Package</td>
            <td>$200</td>
            <td>
              3 video ads (Level 1) + 2 static ads (Level 2) + 1 video ad (Level
              3).
            </td>
          </tr>
        </tbody>
      </table>
      <br />
      5.3 Free Ad Utilization:
      <ul>
        <li>
          Unsold ad slots are allocated to free ads based on sales commission
          potential, content relevance, and engagement likelihood.
        </li>
      </ul>
      5.4 Reader Engagement:
      <ul>
        <li>
          KleverBook™ eBooks offer interactive features for readers, including
          direct hyperlinks to purchase additional Works or products advertised
          within the book.
        </li>
      </ul>
      5.5 Examples of Revenue Share Per Book:
      <table border="1" cellspacing="0" cellpadding="4">
        <thead>
          <tr>
            <th>Book Type</th>
            <th>Total Revenue ($)</th>
            <th>Author/Publisher Share ($)</th>
            <th>KleverBook Share ($)</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>High-Value Books</td>
            <td>450</td>
            <td>225</td>
            <td>225</td>
          </tr>
          <tr>
            <td>Mid-Value Books</td>
            <td>150</td>
            <td>75</td>
            <td>75</td>
          </tr>
          <tr>
            <td>Low-Value Books</td>
            <td>30</td>
            <td>15</td>
            <td>15</td>
          </tr>
        </tbody>
      </table>
      <br />
      <b>6. Term and Termination</b>
      <br />
      6.1 This Agreement will remain in effect until terminated by either party.
      <br />
      6.2 Either party may terminate this Agreement with 30 days’ written
      notice.
      <br />
      6.3 Upon termination, d2p will remove the Seller’s Works from the platform
      within 30 days, and any outstanding payments will be settled within 60
      days.
      <br />
      <br />
      <b>7. Indemnification</b>
      <br />
      The Seller agrees to indemnify and hold harmless d2p, its affiliates,
      officers, directors, and employees from any claims, damages, or
      liabilities arising from the Seller’s breach of this Agreement or
      infringement of any third-party rights.
      <br />
      <br />
      <b>8. Limitation of Liability</b>
      <br />
      To the extent permitted by law, d2p’s total liability under this Agreement
      shall not exceed the total ad revenue earned by d2p from the Seller’s
      sales during the preceding 12 months.
      <br />
      <br />
      <b>9. Governing Law</b>
      <br />
      This Agreement shall be governed by and construed by the laws of the State
      of Nevada, without regard to its conflict of laws principles.
      <br />
      <br />
      <b>10. Entire Agreement</b>
      <br />
      This Agreement constitutes the entire understanding between the parties
      concerning its subject matter and supersedes all prior agreements or
      understandings, whether written or oral.
      <br />
      <br />
      <b>11. Electronic Signature</b>
      <br />
      By typing their name below, the Seller acknowledges and agrees that such
      action constitutes a legally binding electronic signature, equivalent to a
      handwritten signature, and that the Seller is entering into a legally
      enforceable contract with d2p.
      <br />
      <br />
      <b>12. Automatic Acceptance</b>
      <br />
      This Agreement is deemed automatically accepted by d2p upon the Seller’s
      submission of a signed copy or electronic acceptance through d2p’s
      platform. No additional signature from d2p is required for this Agreement
      to take effect.
      <br />
      <br />
    </>
  );
};

export default AgreementDoc;
